// Angular
import {
  Component,
  EventEmitter, OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
// Local services
import { AlertService } from '../../../services/alert.service';
import { ProfileService } from '../profile.service';
import { RoleService } from '../../seguridad-creacion-rol/role.service';
// Messages
import { GlobalMessages } from '../../../utils/messages';
import { Messages } from './messages';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-security-profile-form',
  templateUrl: './security-profile-form.component.html',
  styleUrls: ['./security-profile-form.component.scss']
})
export class SecurityProfileFormComponent implements OnInit, OnDestroy {
  // Decorations
  @Output() selectTab = new EventEmitter<any>();
  // Reactive form
  userForm: FormGroup;
  // Data
  roles = [];
  isEdit = false;
  active;
  // Rxjs
  subscription: Subscription;
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private loaderService: NgxUiLoaderService,
    private profileService: ProfileService,
    private roleService: RoleService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.userForm = this.formBuilder.group({
      user: ['', Validators.required],
      fullName: ['', Validators.required],
      leadership: ['', Validators.required],
      role: ['', Validators.required],
      oldCode: ['', Validators.required],
      job: ['', Validators.required],
      administrativeUnit: ['', Validators.required],
      email: ['', Validators.required],
    });
    await this.getRoles();

    this.subscription = await this.profileService.editProfile.subscribe(data => {
      if (data.edit === true) {
        this.isEdit = true;
        this.active = data.estado_usuario;
        this.userForm.controls.user.setValue(data.usuario);
        this.userForm.controls.fullName.setValue(data.nombre_completo);
        this.userForm.controls.leadership.setValue(data.direccion);
        this.userForm.controls.role.setValue(data.id_rol.toString());
        this.userForm.controls.oldCode.setValue(data.codigo_antiguedad);
        this.userForm.controls.job.setValue(data.puesto);
        this.userForm.controls.administrativeUnit.setValue(data.unidad_administrativa);
        this.userForm.controls.email.setValue(data.correo);
      }
    });
  }

  selectedTab(tab) {
    this.selectTab.emit(tab);
  }

  ngOnDestroy(): void {
    this.isEdit = false;
    this.userForm.reset();
    this.profileService.setProfile({
      edit: false,
    });
    this.subscription.unsubscribe();
  }

  async createUserProfile() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.profileService.createProfile({
      idPerfil: 0,
      idRol: +this.userForm.controls.role.value,
      nombreCompleto: this.userForm.controls.fullName.value,
      codigoAntiguedad: this.userForm.controls.oldCode.value,
      puesto: this.userForm.controls.job.value,
      correo: this.userForm.controls.email.value,
      unidadAdministrativa: this.userForm.controls.administrativeUnit.value,
      direccion: this.userForm.controls.leadership.value,
      usuario: this.userForm.controls.user.value,
      activo: true,
    });

    if (result && result.codigo === 1) {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      const confirm = await this.alertService.confirmation(
        Messages.SUCCESS_PROFILE_ADDED,
        Messages.SUCCESS_PROFILE_ADDED_BODY,
        Messages.GO_TO_LIST_BUTTON_TEXT,
      );

      if (confirm.isConfirmed) {
        this.router.navigate(['/modulo-seguridad/', 'seguridad', 'listado-usuarios']);
        this.selectedTab('listado-usuarios');
      } else {
        this.userForm.reset();
        await this.getRoles();
      }
    } else {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
    }
  }

  async updateProfile() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.profileService.updateProfile({
      idPerfil: 0,
      idRol: +this.userForm.controls.role.value,
      nombreCompleto: this.userForm.controls.fullName.value,
      codigoAntiguedad: this.userForm.controls.oldCode.value,
      puesto: this.userForm.controls.job.value,
      correo: this.userForm.controls.email.value,
      unidadAdministrativa: this.userForm.controls.administrativeUnit.value,
      direccion: this.userForm.controls.leadership.value,
      usuario: this.userForm.controls.user.value,
      activo: this.active,
    });

    if (result && result.codigo === 1) {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      const confirm = await this.alertService.show(
        GlobalMessages.NOTE_TITLE,
        Messages.UPDATE_PROFILE_SUCCESS,
      );
      this.router.navigate(['/modulo-seguridad/', 'seguridad', 'listado-usuarios']);
      this.selectedTab('listado-usuarios');
    } else {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
    }
  }

  async getRoles() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.getRoles();
    if (result && result.codigo === 1) {
      this.roles = result.Respuesta;
      if (this.roles.length > 0) {
        this.userForm.controls.role.setValue(this.roles[0].id_rol);
      }
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
    }
  }

}
